import type { ApolloClient } from "@apollo/client";
import { getWorkspaceHeader, registerWorkspaceScopedClient } from "@ticketon/marketing/workspace";
import { createPlatformAdminClient } from "./platformAdminClient";

const TRAVEL_ADMIN_GRAPHQL_URI = "/platform/admin/travel/graphql";

let travelAdminClient: ApolloClient | null = null;

export function getTravelAdminClient(): ApolloClient {
  if (!travelAdminClient) {
    travelAdminClient = createPlatformAdminClient(TRAVEL_ADMIN_GRAPHQL_URI, {
      // myPermissions also returns the caller's Marketing: grants, which depend on the
      // active marketing workspace, so travel requests carry its id too.
      headers: getWorkspaceHeader,
    });

    // Permissions are re-read when the workspace changes (it is selected once, at start-up).
    registerWorkspaceScopedClient(travelAdminClient);
  }
  return travelAdminClient;
}

export function resetTravelAdminClient(): void {
  travelAdminClient = null;
}
